// TODO: Consider using the SessionStorage API to store the url list, to make surviving a page reload possible.
// TODO: Consider adding a system to block (with help of `onbeforeunload`) or rescue reload callbacks, when using the back button.

import {
    showAnimalDetails,
    showPupDetails,
    showCageDetails,
} from "../dialogs";


type DialogReference = (
    { showAnimalDetails: Parameters<typeof showAnimalDetails>[0] } |
    { showPupDetails: Parameters<typeof showPupDetails>[0] } |
    { showCageDetails: Parameters<typeof showCageDetails>[0] }
);

export class DialogHistory {
    private readonly history: DialogReference[];

    constructor() {
        this.history = [];
    }

    /** Add a DialogReference to the history **/
    public addDialogReference = (item: DialogReference): void => {
        this.history.push(item);
    };

    public goBack = (): void => {
        this.history.pop();  // remove the current item from the list
        if (this.history.length) {
            Object.entries(this.history.pop()).forEach(([dialogName, dialogParams]) => {
                if (dialogName === "showAnimalDetails") {
                    showAnimalDetails(dialogParams);
                } else if (dialogName === "showPupDetails") {
                    showPupDetails(dialogParams);
                } else if (dialogName === "showCageDetails") {
                    showCageDetails(dialogParams);
                }
            });
        }
    };

    public size = (): number => {
        return this.history.length;
    };
}
